// extracted by mini-css-extract-plugin
export default {"disabled":"disabled__bdMfN"};